import { useEffect, useRef } from 'react';

import { useEnvironment, usePanorama } from '@wix/yoshi-flow-editor';

import { useRootProps } from 'AiAssistantWidget/Widget/contexts';

/**
 * Requests are sent with an empty token when the controller got no instance
 * (`getAppToken` returned nothing). Logging it once per mount lets 401s on
 * early requests be matched against sessions that had no token.
 */
export const useReportMissingInstanceToken = () => {
  const panorama = usePanorama();
  const { isEditor, isSSR } = useEnvironment();
  const { instanceToken } = useRootProps();
  const reportedRef = useRef(false);

  useEffect(() => {
    if (isEditor || isSSR || instanceToken || reportedRef.current) {
      return;
    }
    reportedRef.current = true;
    panorama.logger().warn('instance-token-missing');
  }, [isEditor, isSSR, instanceToken, panorama]);
};
